import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material'
import React, { useState } from 'react'
import { getData } from '../../services/api'
import useDebouncedResource from '../../component/useDebouncedResource'
import LoadingOverlay from '../../component/LoadingOverlay'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highcharts'
import { MobileDatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs';
const borderRadius = require('highcharts-border-radius');
borderRadius(Highcharts);

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function IncomeByDate() {
    const [season, setSeason] = useState('all')
    const [type, setType] = useState('all')
    const [sdate, setSdate] = useState(null)
    const [edate, setEdate] = useState(null)
    const { data: rawData, loading } = useDebouncedResource(
        () => getData('dashboard/back/income-by-date', `?startDate=${sdate ? dayjs(sdate).format('YYYY-MM-DD') : ""}&endDate=${edate ? dayjs(edate).format('YYYY-MM-DD') : ""}`).then(res => res?.status === true ? res.result : null),
        JSON.stringify([sdate, edate])
    )
    const data = rawData || []
    return (
        <>
            <div style={{ border: '2px solid #c0d9ff', padding: '10px', background: '#fff', borderRadius: '10px', }}>
                <div class="row">
                    <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "space-between" }}>
                        <h2 className='dash-title'>
                            รายรับจากการจำหน่ายเมล็ดพันธุ์
                        </h2>
                        <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "space-between", '& .backgroundField': { background: "#ff724f" } }}>

                            <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>

                                <MobileDatePicker
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={sdate} onChange={e => setSdate(e)}
                                    slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่เริ่มต้น', fullWidth: true, InputProps: { disableUnderline: true }, value: sdate } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />

                            </Box>

                            <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                                <MobileDatePicker
                                    minDate={sdate}
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={edate} onChange={e => setEdate(e)}
                                    slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่สิ้นสุด', fullWidth: true, InputProps: { disableUnderline: true }, value: edate } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <div class="col-12">
                        <LoadingOverlay loading={loading}>
                            <Dashboard dataDashboard={data} />
                        </LoadingOverlay>
                    </div>
                </div>
            </div>
        </>
    )
}

function Dashboard({ dataDashboard }) {

    const data = dataDashboard?.map((x) =>
        [x?.SaleDayInMonth, +(x?.SaleTotal/1000000).toFixed(2)]
    )
    const options = {
        chart: {
            type: 'column',
            // scrollablePlotArea: {
            //     minWidth: 2000,
            //     scrollPositionX: 1
            // }
            zoomType: 'x'
        },
        title: {
            text: null
        },
        subtitle: {
            text: 'ล้านบาท',
            align: 'left'
        },

        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            title: {
                text:'วัน'
            },
            labels: {
                rotation: -45,
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return this.value.toLocaleString();
                },
            }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                color: '#FFC72C'

                
            },
            series: {
                borderRadiusTopLeft: 8,
                borderRadiusTopRight: 8,
                color: '#FFC72C'
            }
        },
        tooltip: {
            pointFormat: '<b>{point.y} ล้านบาท</b>'
        },
        series: [{
            name: 'Population',
            data: data,
            type: 'column',


        }]
    }
    return (
        <>
            {dataDashboard && <PieChart options={options} highcharts={Highcharts} />}
        </>
    )
}